import React from 'react';
import { Input, InputNumber, Select, Upload, DatePicker, Radio, Button } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import { xToken } from '../../../common/AjaxRequest';
import { lowerToUpper } from '../../shared/formatElem';
import { getMatchOption } from '../../shared/selectFn';
import Text from '../../basicElement/Text';
import format from '../../shared/format';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Group } = Radio;
const { Option } = Select;
const { TextArea } = Input;
const dateFormat = 'YYYY-MM-DD';
const DefaultList = [
    { label: '是', value: '1' },
    { label: '否', value: '0' },
];

function UpdateUI(props) {
    const {
        path,
        Constants,
        isDeductAmount,
        customerWritable,
        record,
        saveParams,
        investigation,
        fileList,
        businessList,
        currencyList,
        signingUnitList,
        contractTypeList,
        belongingToUnitList,
        relationContractList,
        secondLine_disabled,
        secondLineIsEmpty,
        downLoadFile,
        handleChange,
        beforeUpload,
        handleUploadChange,
        handleRemove,
        handleChangeRateCanEdit,
        rateCanEdit,
    } = props;
    saveParams.isRealitySettle=saveParams.investigationJdeContractIsSigned == 1? saveParams.isRealitySettle?saveParams.isRealitySettle:0:null;
    saveParams.isMsaSpecialContractReduce=saveParams.isRealitySettle == 0?saveParams.isDiscountTermValidity ==1?saveParams.isMsaSpecialContractReduce?saveParams.isMsaSpecialContractReduce:0:null:null;
    const {
        jdeApplyId,
        investigationJdeContractId,
        investigationJdeContractIsSigned,
        jdeContractAmount,
        actualExpenseFee,
        taxationFee,
        rate,
        contractNature,
        exchangeRate,                         // 汇率
        currencyName,                         // 币种名字
        currencyCode,
        isRealitySettle=0,//是否据实计算
        isMsaSpecialContractReduce=0,//是否从合同中扣减
        isMsaSpecialDiscountCustom, //是否优惠客户
        isDiscountTermValidity, //是否有效期内
        discountContractAmount,
    } = saveParams;
    const { isClinicalProject } = investigation;
    const isAdd = Constants.add;                                                   // 添加状态
    const isJdeCreate = !!jdeApplyId;                                              // jde建号生成
    const isClinicalPro = isClinicalProject == 1;
    const contractHasSigned = investigationJdeContractIsSigned == 1;               // 合同已签署
    const contractHasSelected = investigationJdeContractIsSigned != undefined;     // 合同是否签署已选
    const FIRST_CONTRACT = contractNature === 'FIRST_CONTRACT';                    // 首次合同
    const RENEW_CONTRACT = contractNature === 'RENEW_CONTRACT';                    // 续签合同
    const CNY = currencyCode === 'CNY';  // 是否是人民币
    const isRealitySettleed = isRealitySettle === 0;// 据实结算 否
    const isMsaSpecialContractReduceed = isMsaSpecialContractReduce == '1';// MSA特殊优惠从合同额中扣减
    const isMsaSpecialDiscountCustomed = isMsaSpecialDiscountCustom == 1 ;
    const isDiscountTermValidityed = isDiscountTermValidity == 1 ;
    const isMsaSpecialContractReduceValue = isMsaSpecialContractReduce?isMsaSpecialContractReduce:0;
    const relationJdeRequired = !!(!FIRST_CONTRACT || (Constants.add && relationContractList.length) || (Constants.edit && record.relationContractId));
    
    let { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', saveParams.lineOfBusiness);
    // 项目编号包含’遗传办‘或’安全事务‘时，执行业务线二级分类选项只有对应的关键项
    const containHeredity = (saveParams.investigationCode || '').indexOf('遗传办') > -1;
    const containSecurityTransaction = (saveParams.investigationCode || '').indexOf('安全事务') > -1;
    let disabled = false;
    secondLineList = (secondLineList || []).filter(i => {
        if (isClinicalPro && containHeredity) {
            disabled = true;
            return i.typeValue === '遗传办';
        } else if (isClinicalPro && containSecurityTransaction) {
            disabled = true;
            return i.typeValue === '安全事务';
        } else {
            return true;
        }
    });
    const showSecondLine = (secondLineList || []).length > 0;
    const settings = {};
    let secondLineValue = saveParams.secondLineIds ? saveParams.secondLineIds + '' : undefined;
    if (!isClinicalPro) {
        settings.mode = 'multiple';
        secondLineValue = saveParams.secondLineIds ? saveParams.secondLineIds.split(',') : [];
    }

    const relationContractOption = relationContractList.map(i => <Option key={i.investigationJdeContractId} value={i.investigationJdeContractId}>{i.investigationJdeContractCode}</Option>);
    const secondLineOption = (secondLineList || []).map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);
    const signingUnitOption = signingUnitList.map(i => <Option key={i.unitOfSigningId} value={i.unitOfSigningId}>{i.unitOfSigningName}</Option>);
    const belongingToUnitOption = belongingToUnitList.map(i => <Option key={i.unitOfBelongingId} value={i.unitOfBelongingId}>{i.unitOfBelongingName}</Option>);
    const currencyOption = currencyList.map(i => <Option key={i.currencyExchangeRateId} value={i.currencyExchangeRateId}>{format('joint', i.currencyName, i.currencyCode, 'roundBrackets')}</Option>);
    const contractTypeOption = contractTypeList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);

    // 税率
    let showRateMes = rate ? rate < 6 || rate > 8 : false;
    if( (!rate || rate == '') && (!taxationFee || taxationFee == '') && rateCanEdit) handleChangeRateCanEdit (false);
    if(rateCanEdit == 'rmb') {
        let rateValue = '';
        if ((taxationFee || taxationFee === 0) && (jdeContractAmount || jdeContractAmount === 0)) {
            if (jdeContractAmount - taxationFee == 0) {
                if (jdeContractAmount === 0) {
                    rateValue = 0;
                } else {
                    rateValue = 100;
                }
            } else {
                rateValue = taxationFee / (jdeContractAmount - taxationFee) * 100;
                rateValue = Number.isNaN(rateValue) ? '' : myFixed(rateValue,2);
            }
            if( rateValue != rate && rateValue != '') {
                handleChangeRateCanEdit ('rmb');
                handleChange(rateValue, 'rate', false);
            }
        }
        if(rateValue == '' && rate != null){
            handleChangeRateCanEdit (false);
            handleChange(null, 'rate', false);
        }
    }
    if(rateCanEdit == 'rate') {
        let taxationFeeValue = '';
        if ((rate || rate === 0) && (jdeContractAmount || jdeContractAmount === 0)) {
            taxationFeeValue = jdeContractAmount - jdeContractAmount / ( 1 + rate / 100 );
            taxationFeeValue = Number.isNaN(taxationFeeValue) ? '' : myFixed(taxationFeeValue,2);
            if( taxationFeeValue != taxationFee && taxationFeeValue != '') {
                handleChangeRateCanEdit ('rate');
                handleChange(taxationFeeValue, 'taxationFee', false);
            }
        }
        if(taxationFeeValue == '' && taxationFee != null){
            handleChangeRateCanEdit (false);
            handleChange(null, 'taxationFee', false);
        }
    }
    //优惠金额（不含税）
    let discountContractAmountNoTaxValue ='';
    if((discountContractAmount || discountContractAmount == 0)&& (rate || rate == 0)){
        discountContractAmountNoTaxValue = discountContractAmount*(1-rate/100);
        discountContractAmountNoTaxValue = Number.isNaN(discountContractAmountNoTaxValue) ? '' : myFixed(discountContractAmountNoTaxValue,2)
        // handleChange(discountContractAmountNoTaxValue, 'discountContractAmountNoTax')
    }
    function myFixed(num, digit) {
            if(Object.is(parseFloat(num), NaN)) {
            return console.log(`传入的值：${num}不是一个数字`);
            }
            num = parseFloat(num);
            return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
        }

    function getOptions(list, type) {
        switch(type) {
            case 'radio':
                return list.map(d => <Radio value={d.value}>{d.label}</Radio>);
            default:
                return list.map(d => <Option key={d.value}>{d.label}</Option>);
        }
    }

    function getContractDom(key, width, disabled = true) {
        return (
            <InputNumber
                maxLength="17"
                placeholder="请输入"
                precision={2}
                disabled={!disabled}
                max={99999999999}
                style={{ width }}
                value={saveParams[key]}
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                onChange={value => handleChange(value, key)}
            />
        );
    }
    function customerCompanyChange(value){
        const MsaSpecialDiscountCustom=value.isMsaSpecialDiscountCustom;
        const DiscountTermValidity=value.isDiscountTermValidity;
         handleChange(MsaSpecialDiscountCustom, 'isMsaSpecialDiscountCustom')
         handleChange(DiscountTermValidity, 'isDiscountTermValidity')
     }
    return (
        <ul className="preview-list nobg child-jde">
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label"><Text asterisk={isAdd}>JDE项目号</Text></label>
                    <span className="ui-text">
                        {
                            isAdd ?
                                <Input
                                    maxLength={12}
                                    placeholder="请输入"
                                    style={{ width: 182 }}
                                    value={saveParams.investigationJdeContractCode}
                                    onChange={e => handleChange(e.target.value, 'investigationJdeContractCode')}
                                />
                            :
                                saveParams.investigationJdeContractCode
                        }
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    {/* 合同已签署时不能修改 */}
                    <label className="ui-label"><Text asterisk={isAdd || (!isJdeCreate && record.investigationJdeContractIsSigned != 1)}>合同或函证是否签署</Text></label>
                    <span className="ui-text">
                        {
                            (isAdd || (!isJdeCreate && record.investigationJdeContractIsSigned != 1)) ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={saveParams.investigationJdeContractIsSigned}
                                    onChange={value => handleChange(value, 'investigationJdeContractIsSigned')}
                                >
                                    {getOptions(DefaultList)}
                                </Select>
                            :
                                getMatchOption(DefaultList, 'value', saveParams.investigationJdeContractIsSigned).label
                        }
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label"><Text asterisk={isAdd}>合同性质</Text></label>
                    <span className="ui-text">
                        {
                            (isAdd || !saveParams.contractNatureShow) ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={saveParams.contractNature}
                                    onChange={value => handleChange(value, 'contractNature')}
                                >
                                    <Option value='FIRST_CONTRACT'>首次合同</Option>
                                    {/* 合同未签署时不可选补充合同 */}
                                    <Option value='SUPPLEMENT_CONTRACT' disabled={!contractHasSigned}>补充合同</Option>
                                    <Option value='RENEW_CONTRACT'>续签合同</Option>
                                </Select>
                            :
                                saveParams.contractNatureShow
                        }
                    </span>
                </div>
            </li>
            {
                contractHasSelected &&
                <div>
                    <li className="preview-item">
                        <div className="item">
                            {/* 非首次合同，需选择 */}
                            <label className="ui-label"><Text asterisk={relationJdeRequired && !isJdeCreate}>关联JDE</Text></label>
                            <span className="ui-text">
                                {
                                    !isJdeCreate ?
                                        <Select
                                            placeholder='请选择'
                                            allowClear={true}
                                            style={{ width: 182 }}
                                            disabled={isDeductAmount}
                                            value={saveParams.relationContractId}
                                            onChange={value => handleChange(value, 'relationContractId')}
                                        >
                                            {relationContractOption}
                                        </Select>
                                    :
                                        saveParams.relationContractCode
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">申办方</label>
                            <span className="ui-text">{saveParams.investigationSponsor}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">项目编号</label>
                            <span className="ui-text">{saveParams.investigationCode}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            {/* 不是续签合同时，需选择 */}
                            <label className="ui-label"><Text asterisk={customerWritable || (!RENEW_CONTRACT && !isJdeCreate)}>客户全名</Text></label>
                            <span className="ui-text">
                                {
                                    (customerWritable || (!RENEW_CONTRACT && !isJdeCreate)) ?
                                        <SearchRetrieve
                                            keyword='customerCompanyName'
                                            style={{ width: 182 }}
                                            placeholder="输入名称检索"
                                            params={{ limit: 20 }}
                                            value={saveParams.customerCompanyName}
                                            url={API_URL.investigation.queryCustomerCompanyByName}
                                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                            onChange={(option) => {
                                                handleChange(option, 'customerCompany')
                                                customerCompanyChange(option)
                                            }}
                                        />
                                    :
                                        saveParams.customerCompanyName
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">客户JDE号</label>
                            <span className="ui-text">{saveParams.customerJdeCode}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={!isJdeCreate}>BA</Text></label>
                            <span className="ui-text">
                                {
                                    !isJdeCreate ?
                                        <SearchRetrieve
                                            keyword='keyWord'
                                            style={{ width: 182 }}
                                            placeholder="输入姓名/工号检索"
                                            value={saveParams.baUserName}
                                            params={{ limit: 20, roleCodes: 'BA,BAL' }}
                                            url={API_URL.teaching.queryEmpListByRoleCode}
                                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                            onChange={(option) => handleChange(option, 'baUser')}
                                        />
                                    :
                                        saveParams.baUserName
                                }
                            </span>
                        </div>
                    </li>
                </div>
            }
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">业务线</label>
                    <span className="ui-text">{saveParams.lineOfBusinessString}</span>
                </div>
            </li>
            {
                contractHasSelected &&
                <div>
                    {
                        showSecondLine &&
                        <li className="preview-item">
                            <div className="item">
                                {/* 首次合同，需选择 */}
                                <label className="ui-label"><Text asterisk={secondLineIsEmpty}>执行业务线二级分类</Text></label>
                                <span className="ui-text">
                                    {
                                        secondLineIsEmpty ?
                                            <Select
                                                allowClear={true}
                                                placeholder="请选择"
                                                style={{ width: 182 }}
                                                disabled={secondLine_disabled || disabled}
                                                value={secondLineValue}
                                                onChange={value => handleChange(value, 'secondLineIds')}
                                                {...settings}
                                            >
                                                {secondLineOption}
                                            </Select>
                                        :
                                            saveParams.secondLineNames
                                    }
                                </span>
                            </div>
                        </li>
                    }
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={!isJdeCreate}>合同签署单位</Text></label>
                            <span className="ui-text">
                                {
                                    !isJdeCreate ?
                                        <Select
                                            placeholder="请选择"
                                            style={{ width: 182 }}
                                            value={saveParams.signingUnit}
                                            onChange={value => handleChange(value, 'signingUnit')}
                                        >
                                            {signingUnitOption}
                                        </Select>
                                    :
                                        getMatchOption(signingUnitList, 'unitOfSigningId', saveParams.signingUnit).unitOfSigningName
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={!isJdeCreate}>收入归属单位</Text></label>
                            <span className="ui-text">
                                {
                                    !isJdeCreate ?
                                        <Select
                                            placeholder="请选择"
                                            style={{ width: 182 }}
                                            disabled={!saveParams.signingUnit}
                                            value={saveParams.belongingToUnit}
                                            onChange={value => handleChange(value, 'belongingToUnit')}
                                        >
                                            {belongingToUnitOption}
                                        </Select>
                                    :
                                    saveParams.belongingToUnitName
                                }
                            </span>
                        </div>
                    </li>
                    {
                        contractHasSigned &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label"><Text asterisk={!isJdeCreate}>合同中是否明标合同金额</Text></label>
                                <span className="ui-text">
                                    {
                                        !isJdeCreate ?
                                            <Group onChange={e => handleChange(e.target.value, 'jdeContractIsSpecifiesAmount')} value={saveParams.jdeContractIsSpecifiesAmount}>
                                                {getOptions(DefaultList, 'radio')}
                                            </Group>
                                        :
                                            getMatchOption(DefaultList, 'value', saveParams.jdeContractIsSpecifiesAmount).label
                                    }
                                </span>
                            </div>
                        </li>
                    }
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={!isJdeCreate}>币种</Text></label>
                            <span className="ui-text">
                                {
                                    !isJdeCreate ?
                                        <Select
                                            placeholder="请选择"
                                            style={{ width: 182 }}
                                            value={saveParams.currencyExchangeRateId}
                                            onChange={value => handleChange(value, 'currencyExchangeRateId')}
                                        >
                                            {currencyOption}
                                        </Select>
                                    :
                                        format('joint', currencyName, currencyCode, 'roundBrackets')
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={!CNY && !isJdeCreate}>汇率</Text></label>
                            <span className="ui-text">
                                {
                                    (!CNY && !isJdeCreate) ?
                                        <InputNumber
                                            placeholder="请输入"
                                            style={{ width: 182 }}
                                            value={saveParams.exchangeRate}
                                            onChange={value => handleChange(value, 'exchangeRate')}
                                        />
                                    :
                                        saveParams.exchangeRate
                                }
                            </span>
                        </div>
                    </li>
                    {
                        !contractHasSigned ?
                            (
                                CNY ?
                                    <div>
                                        <li className="preview-item">
                                            <div className="item">
                                                <label className="ui-label"><Text asterisk={!isJdeCreate}>预计合同金额/人民币</Text></label>
                                                <span className="ui-text">
                                                    {
                                                        !isJdeCreate ?
                                                            getContractDom('expectContractAmount', 182)
                                                        :
                                                            format('money', saveParams.expectContractAmount)
                                                    }&nbsp;元
                                                </span>
                                            </div>
                                        </li>
                                        {lowerToUpper(saveParams.expectContractAmount, 230)}
                                    </div>
                                :
                                    <div className="jde-rate">
                                        <div className="left" style={{ width: '50%' }}>
                                            <div className="left lable" style={{ width: '50%' }}><Text asterisk={!isJdeCreate}>预计合同金额/原币</Text></div>
                                            <div className="right text-com" style={{ width: '50%' }}>
                                                {
                                                    !isJdeCreate ?
                                                        getContractDom('expectContractAmount', 100)
                                                    :
                                                        format('money', saveParams.expectContractAmount)
                                                }&nbsp;{saveParams.currencyName}
                                            </div>
                                        </div>
                                        <div className="right" style={{ width: '50%' }}>
                                            <div className="left lable" style={{ width: '50%' }}>预计合同金额/人民币</div>
                                            <div className="right text-com" style={{ width: '50%' }}>
                                                {format('money', saveParams.expectContractAmount, saveParams.exchangeRate)}&nbsp;元
                                            </div>
                                        </div>
                                    </div>
                            )
                        :
                            (
                                CNY ?
                                    <div>
                                        <li className="preview-item">
                                            <div className="item">
                                                <label className="ui-label"><Text asterisk={!isJdeCreate}>合同额含税/人民币</Text></label>
                                                <span className="ui-text">
                                                    {
                                                        !isJdeCreate ?
                                                            getContractDom('jdeContractAmount', 182)
                                                        :
                                                            format('money', saveParams.jdeContractAmount)
                                                    }&nbsp;元
                                                </span>
                                            </div>
                                        </li>
                                        {lowerToUpper(saveParams.jdeContractAmount, 245)}
                                        <li className="preview-item">
                                            <div className="item">
                                                <label className="ui-label">合同税率</label>
                                                <span className="ui-text">
                                                { !isJdeCreate ? getContractDom('rate', 182, !rateCanEdit || rateCanEdit == 'rate') : rate} &nbsp;%
                                                {
                                                    showRateMes && <span style={{ color: 'red', padding: '0 10px' }}>税率范围：6%~8%</span>
                                                }</span>
                                            </div>
                                        </li>
                                        <div className="FeeBackground" style={{ width: '80%' }}>
                                            <div style={{ position: 'absolute', top: 0, left: 0, right: '88%', bottom: 0, background: '#f9f9f9', borderRight: "1px solid #ccc" }}>
                                                <span style={{ position: "absolute", left: "10px", top: "50%", transform: 'translateY(-50%)' }}>&nbsp;其中<br />需扣除</span>
                                            </div>
                                            <div style={{ height: "100%", marginLeft: '12%' }}>
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label">实报实销(不含税)/人民币</label>
                                                        <span className="ui-text">
                                                            {
                                                                !isJdeCreate ?
                                                                    getContractDom('actualExpenseFee', 182)
                                                                :
                                                                    format('money', saveParams.actualExpenseFee)
                                                            }&nbsp;元
                                                        </span>
                                                    </div>
                                                </li>
                                                {lowerToUpper(saveParams.actualExpenseFee)}
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label">实报实销税费/人民币</label>
                                                        <span className="ui-text">
                                                            {
                                                                !isJdeCreate ?
                                                                    getContractDom('actualFee', 182)
                                                                :
                                                                    format('money', saveParams.actualFee)
                                                            }&nbsp;元
                                                        </span>
                                                    </div>
                                                </li>
                                                {lowerToUpper(saveParams.actualFee)}
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label">合同额税费/人民币</label>
                                                        <span className="ui-text">
                                                            {
                                                                !isJdeCreate ?
                                                                getContractDom('taxationFee', 182, !rateCanEdit || rateCanEdit == 'rmb')
                                                                :
                                                                    format('money', saveParams.taxationFee)
                                                            }&nbsp;元
                                                        </span>
                                                    </div>
                                                </li>
                                                {lowerToUpper(saveParams.taxationFee)}
                                            </div>
                                        </div>
                                    </div>
                                :
                                    <div className="jde-rate">
                                        <div>
                                            <div className="left" style={{ width: '55%' }}>
                                                <div className="left lable" style={{ width: '59.4%' }}><Text asterisk={!isJdeCreate}>合同额含税/原币</Text></div>
                                                <div className="right text-com" style={{ width: '40.6%' }}>
                                                    {
                                                        !isJdeCreate ?
                                                            getContractDom('jdeContractAmount', 100)
                                                        :
                                                            format('money', saveParams.jdeContractAmount)
                                                    }&nbsp;{saveParams.currencyName}
                                                </div>
                                            </div>
                                            <div className="right" style={{ width: '45%' }}>
                                                <div className="left lable" style={{ width: '50%' }}>合同额含税/人民币</div>
                                                <div className="right text-com" style={{ width: '50%' }}>
                                                    {format('money', saveParams.jdeContractAmount, saveParams.exchangeRate)}&nbsp;元
                                                </div>
                                            </div>
                                        </div>
                                        <div className="jde-top">
                                            <div className="left lable" style={{ width: '10%', textAlign: 'center', borderRight: 0 }}>其中<br />需扣除</div>
                                            <div className="right jde-left" style={{ width: '90%' }}>
                                                <div>
                                                    <div className="left" style={{ width: '50%' }}>
                                                        <div className="left lable" style={{ width: '50%' }}>实报实销(不含税)/原币</div>
                                                        <div className="right text-com" style={{ width: '50%' }}>
                                                            {
                                                                !isJdeCreate ?
                                                                    getContractDom('actualExpenseFee', 100)
                                                                :
                                                                    format('money', saveParams.actualExpenseFee)
                                                            }&nbsp;{saveParams.currencyName}
                                                        </div>
                                                    </div>
                                                    <div className="right" style={{ width: '50%' }}>
                                                        <div className="left lable" style={{ width: '50%' }}>实报实销(不含税)/人民币</div>
                                                        <div className="right text-com" style={{ width: '50%' }}>
                                                            {format('money', actualExpenseFee, exchangeRate)}&nbsp;元
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="jde-bottom">
                                                    <div className="left" style={{ width: '50%' }}>
                                                        <div className="left lable" style={{ width: '50%' }}>实报实销税费/原币</div>
                                                        <div className="right text-com" style={{ width: '50%' }}>
                                                            {
                                                                !isJdeCreate ?
                                                                    getContractDom('actualFee', 100)
                                                                :
                                                                    format('money', saveParams.actualFee)
                                                            }&nbsp;{saveParams.currencyName}
                                                        </div>
                                                    </div>
                                                    <div className="right" style={{ width: '50%' }}>
                                                        <div className="left lable" style={{ width: '50%' }}>实报实销税费/人民币</div>
                                                        <div className="right text-com" style={{ width: '50%' }}>
                                                            {format('money', saveParams.actualFee, saveParams.exchangeRate)}&nbsp;元
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="jde-bottom">
                                                    <div className="left" style={{ width: '50%' }}>
                                                        <div className="left lable" style={{ width: '50%' }}><Text asterisk={!isJdeCreate}>合同额税费/原币</Text></div>
                                                        <div className="right text-com" style={{ width: '50%' }}>
                                                            {
                                                                !isJdeCreate ?
                                                                getContractDom('taxationFee', 100, !rateCanEdit || rateCanEdit == 'rmb')
                                                                :
                                                                    format('money', saveParams.taxationFee)
                                                            }&nbsp;{saveParams.currencyName}
                                                        </div>
                                                    </div>
                                                    <div className="right" style={{ width: '50%' }}>
                                                        <div className="left lable" style={{ width: '50%' }}>合同额税费/人民币</div>
                                                        <div className="right text-com" style={{ width: '50%' }}>
                                                            {format('money', saveParams.taxationFee, saveParams.exchangeRate)}&nbsp;元
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="jde-top">
                                            <div className="left lable" style={{ width: '32.6%' }}><Text asterisk={!isJdeCreate}>合同税率</Text></div>
                                            <div className="right text-com" style={{ width: '67.4%' }}>{getContractDom('rate', 100, !rateCanEdit || rateCanEdit == 'rate')} &nbsp;%
                                            {
                                                showRateMes && <span style={{ color: 'red', padding: '0 10px' }}>税率范围：6%~8%</span>
                                            }</div>
                                        </div>
                                    </div>
                            )
                    }
                    {
                        contractHasSigned &&
                        <div>
                            {
                                FIRST_CONTRACT && saveParams.relationContractId &&
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label"><Text asterisk={!isJdeCreate}>关联JDE是否需要扣除相应金额</Text></label>
                                        <span className="ui-text">
                                            {
                                                !isJdeCreate ?
                                                    <Group
                                                        disabled={isDeductAmount}
                                                        value={saveParams.relateJdeIsDeductAmount}
                                                        onChange={e => handleChange(e.target.value, 'relateJdeIsDeductAmount')}
                                                    >
                                                        {getOptions(DefaultList, 'radio')}
                                                    </Group>
                                                :
                                                    getMatchOption(DefaultList, 'value', saveParams.relateJdeIsDeductAmount).label
                                            }
                                        </span>
                                    </div>
                                </li>
                            }
                            <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label"><Text asterisk={true}>是否据实结算</Text></label>
                                            <span className="ui-text">
                                                {
                                                    (isAdd || record.investigationJdeContractIsSigned != 1) ?
                                                        <Group  onChange={e => handleChange(e.target.value, 'isRealitySettle')} value={isRealitySettle}>
                                                            <Radio key={1} value={1}>是</Radio>
                                                            <Radio key={0} value={0}>否</Radio>
                                                        </Group>
                                                    :
                                                        getMatchOption(DefaultList, 'value', saveParams.isRealitySettle).label
                                                }
                                                
                                            </span>
                                        </div>
                                    </li>
                            
                            {
                                isRealitySettleed &&  isDiscountTermValidityed &&
                                (<div>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label" style={{padding:'0'}}><Text asterisk={true}>MSA特殊优惠是否从合同额中扣减</Text></label>
                                            <span className="ui-text">
                                                {
                                                    (isAdd || record.investigationJdeContractIsSigned != 1) ?
                                                    <Group  onChange={e => handleChange(e.target.value, 'isMsaSpecialContractReduce')} value={isMsaSpecialContractReduceValue}>
                                                        <Radio key={1} value={1}>是</Radio>
                                                        <Radio key={0} value={0}>否</Radio>
                                                    </Group>
                                                    :
                                                    getMatchOption(DefaultList, 'value', isMsaSpecialContractReduceValue).label
                                                }
                                                
                                            </span>
                                        </div>
                                    </li>
                                    {
                                        isMsaSpecialContractReduceed &&  (
                                            <div>
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label"><Text asterisk={true}>优惠金额（含税）/人民币</Text></label>
                                                        <span className="ui-text">
                                                            {
                                                                (isAdd || record.investigationJdeContractIsSigned != 1) ?
                                                                getContractDom('discountContractAmount', 182):
                                                                discountContractAmount
                                                            }&nbsp;元
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label">优惠金额（不含税）/人民币</label>
                                                        <span className="ui-text" style={{ width: 186 }}>
                                                            {discountContractAmountNoTaxValue}&nbsp;元
                                                        </span>
                                                    </div>
                                                </li>
                                            </div>
                                        )
                                    }
                                </div>)
                            }
                            
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={!isJdeCreate}>合同开始时间</Text></label>
                                    <span className="ui-text">
                                        {
                                            !isJdeCreate ?
                                                <DatePicker
                                                    format={dateFormat}
                                                    placeholder="请选择"
                                                    style={{ width: 182 }}
                                                    value={saveParams.startTime ? moment(saveParams.startTime) : null}
                                                    onChange={(date, dateString) => handleChange(dateString, 'startTime')}
                                                />
                                            :
                                                format('date', saveParams.startTime)
                                        }
                                    </span>
                                </div>
                            </li>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={!isJdeCreate}>合同结束时间</Text></label>
                                    <span className="ui-text">
                                        {
                                            !isJdeCreate ?
                                                <DatePicker
                                                    format={dateFormat}
                                                    placeholder="请选择"
                                                    style={{ width: 182 }}
                                                    value={saveParams.endTime ? moment(saveParams.endTime) : null}
                                                    onChange={(date, dateString) => handleChange(dateString, 'endTime')}
                                                />
                                            :
                                                format('date', saveParams.endTime)
                                        }
                                    </span>
                                </div>
                            </li>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={!isJdeCreate}>发票税率</Text></label>
                                    <span className="ui-text">
                                        {
                                            !isJdeCreate ?
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    precision={2}
                                                    placeholder="请输入"
                                                    style={{ width: 182 }}
                                                    value={saveParams.invoiceRate}
                                                    onChange={e => handleChange(e, 'invoiceRate')}
                                                />
                                            :
                                                saveParams.invoiceRate
                                        }&nbsp; %
                                    </span>
                                </div>
                            </li>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={!isJdeCreate}>名称(ProjectID)</Text></label>
                                    <span className="ui-text">
                                        {
                                            !isJdeCreate ?
                                                <Input
                                                    placeholder="请输入"
                                                    style={{ width: 182 }}
                                                    value={saveParams.projectIdName}
                                                    onChange={e => handleChange(e.target.value, 'projectIdName')}
                                                />
                                            :
                                                saveParams.projectIdName
                                        }
                                    </span>
                                </div>
                            </li>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={!isJdeCreate}>计收入确认方式</Text></label>
                                    <span className="ui-text">
                                        {
                                            !isJdeCreate ?
                                                <Select
                                                    placeholder="请选择"
                                                    style={{ width: 182 }}
                                                    value={saveParams.contractTypeId}
                                                    onChange={value => handleChange(value, 'contractTypeId')}
                                                >
                                                    {contractTypeOption}
                                                </Select>
                                            :
                                                saveParams.contractTypeValue
                                        }
                                    </span>
                                </div>
                            </li>
                        </div>
                    }
                </div>
            }
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">备注</label>
                    <span className="ui-text">
                        <TextArea
                            placeholder="请输入"
                            value={saveParams.comments}
                            style={{ width: 182, height: 80 }}
                            onChange={e => handleChange(e.target.value, 'comments')}
                        />
                    </span>
                </div>
            </li>
            {
                contractHasSelected &&
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label"><Text asterisk={!isJdeCreate}>{ contractHasSigned ? '上传附件' : '提前上岗授权函' }</Text></label>
                        <span className="ui-text">
                            {
                                !isJdeCreate ?
                                    <Upload
                                        action={API_URL.contract.uploadJdeCodeEnclosure}
                                        data={{
                                            path,
                                            uploadType: contractHasSigned ? 'CONTRACT' : 'ADVANCE_WORK',
                                            investigationJdeContractId: investigationJdeContractId || '',
                                            curUserId: sessionStorage.userId,
                                            curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                        }}
                                        beforeUpload={beforeUpload}
                                        onChange={handleUploadChange}
                                        onRemove={handleRemove}
                                        fileList={fileList}
                                        headers={xToken}
                                    >
                                        <Button style={{ width: 80 }}>选择文件</Button>
                                    </Upload>
                                :
                                    fileList.map(i => <a onClick={e => downLoadFile(e, i.response.fileMetaId)}>{i.name}<br /></a>)
                            }
                        </span>
                    </div>
                </li>
            }
        </ul>
    );
}

export default UpdateUI;


// WEBPACK FOOTER //
// ./src/components/projectContract/childContract/UpdateUI.js